<template>
  <div class="data-up" v-loading="ExportLoading">
    <div class="data-overall-filter">
      <el-form ref="formOverall" :model="formOverall" class="release-form" :inline="true">
        <div class="periodListBox">
          <ul class="periodList">
            <li
              class="buttonItem"
              :class="periodActive === 0 ? 'active' : ''"
              @click="get_date(-1, -1, 0)"
            >
              昨日
            </li>
            <li
              class="buttonItem"
              :class="periodActive === 1 ? 'active' : ''"
              @click="get_date(-7, 0, 1)"
            >
              近7日
            </li>
            <li
              class="buttonItem"
              :class="periodActive === 2 ? 'active' : ''"
              @click="get_date(-30, 0, 2)"
            >
              近30日
            </li>
          </ul>
        </div>
        <el-form-item label="查询时间:" class="release-label">
          <el-date-picker
            :unlink-panels="true"
            v-model="formOverall.time"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            class="release-select-time"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="员工:" class="release-label">
          <el-input v-model="formOverall.name" placeholder="请输入员工姓名" />
        </el-form-item>
        <el-button type="primary" @click="onSubmitOverall" :loading="bottonLoading">筛选</el-button>
        <div class="data-Export" @click="summaryDataExport">
          <img alt="" :src="g_imgSrc.export" class="data-Export-img" />
          <div class="Export">导出文档</div>
        </div>
      </el-form>
    </div>
    <div class="release-list" v-loading="tableLoading">
      <div class="release-list-header">
        <div class="release-list-header-item item-width-content">员工</div>
        <div class="release-list-header-item item-width-time">部门</div>
        <div class="release-list-header-item item-width-auth">敏感词记录数</div>
        <div class="release-list-header-item item-width-account">最后一次监控到敏感词时间</div>
      </div>
      <div class="release-list-body" :id="tableDataOverall.length === 0 ? 'min-h-id' : ''">
        <div v-if="tableDataOverall.length === 0" class="release-list-noData">
          <img alt="" class="release-list-noData-img" :src="g_imgSrc.bgWhite" />
          <div class="release-list-noData-word">暂无相关内容</div>
        </div>
        <div
          class="release-list-item"
          :key="data.id"
          v-for="(data, index) in tableDataOverall"
          @click="openDetail(data, index)"
        >
          <div class="item-time item-width-content">
            <div class="item-time-inner">
              <span class="tree-icon" :class="{ on: list_index === index }"></span>
              {{ data.user_name }}
            </div>
          </div>
          <div class="item-time item-width-time">
            <div class="item-time-inner" :title="data.department_name">
              {{ data.department_name }}
            </div>
          </div>
          <div class="item-time item-width-auth">
            <div class="item-time-inner">
              {{ data.word_count }}
            </div>
          </div>
          <div class="item-time item-width-account">
            <div class="item-time-inner">
              {{ data.last_hit_time }}
            </div>
          </div>
          <div class="item-more" v-show="data.RecordListSubordinate && list_index === index">
            <div class="release-list" v-loading="tableLoading">
              <div class="release-list-header">
                <div class="release-list-header-item item-width-subordinate1">拦截敏感词</div>
                <div class="release-list-header-item item-width-subordinate1">所属规则</div>
                <div class="release-list-header-item item-width-subordinate1">发送人</div>
                <div class="release-list-header-item item-width-subordinate1">部门</div>
                <div class="release-list-header-item item-width-subordinate2">消息来源</div>
                <div class="release-list-header-item item-width-subordinate2">发送时间</div>
              </div>
              <div class="release-list-body" :id="tableDataOverall.length === 0 ? 'min-h-id' : ''">
                <div v-if="tableDataOverall.length === 0" class="release-list-noData">
                  <img alt="" class="release-list-noData-img" :src="g_imgSrc.bgWhite" />
                  <div class="release-list-noData-word">暂无相关内容</div>
                </div>
                <div
                  class="release-list-item"
                  :key="index2"
                  v-for="(data2, index2) in data.RecordListSubordinate"
                >
                  <div class="item-time item-width-subordinate1">
                    <div class="item-time-inners" :title="data2.word">
                      {{ data2.word }}
                    </div>
                  </div>
                  <div class="item-time item-width-subordinate1">
                    <div class="item-time-inners" :title="data2.rule_name">
                      {{ data2.rule_name }}
                    </div>
                  </div>
                  <div class="item-time item-width-subordinate1">
                    <div class="item-time-inners" :title="data2.from_name">
                      {{ data2.from_name }}
                    </div>
                  </div>
                  <div class="item-time item-width-subordinate1">
                    <div class="item-time-inners" :title="data2.from_department_name">
                      {{ data2.from_department_name }}
                    </div>
                  </div>
                  <div class="item-time item-width-subordinate2">
                    <div class="item-time-inners">
                      {{ !data2.room_id ? '群聊' : '与' + data2.room_id + '的聊天' }}
                    </div>
                  </div>
                  <div class="item-time item-width-subordinate2">
                    <div class="item-time-inners" :title="data2.msg_time">
                      {{ data2.msg_time }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        class="pagination"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
        :page-sizes="g_pageSizesConfig"
        :page-size="size"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import {
  EyaoSaaSQuerySensitiveRecordList,
  EyaoSaaSQuerySensitiveRecord,
  EyaoSaaSDownloadSensitiveRecords,
} from '@/api/enterpriseWeChatManagement';
import moment from 'moment';
export default {
  data() {
    return {
      periodActive: 0,
      currentSelect: {
        // value
        // lable
      }, // 选择器选中的当前值
      options: [
        {
          label: '公众号',
          value: '0',
        },
        {
          label: '小程序',
          value: 'wxc4ce208607jjj7',
        },
        {
          label: '全部',
          value: '1',
        },
      ], // 选择器的选项
      formOverall: {
        name: '', // 员工名称
        app_id: null, // 发布账号
        time: [], // 查询时间
      },
      accountList: [], // 发布账号列表
      tableDataOverall: [], // 表格整体数据数据
      total: 1, // 总页数
      currentPage: 1, // 页数
      size: 10, // 每页数量
      role: '', // 权限信息
      publicloding: false, // 发布账号loding
      tableLoading: false, // tableLoading框
      loginerInfo: null, // 获取存储的信息
      bottonLoading: false, // button loading
      ExportLoading: false, // 导出的loading
      req: {
        app_id: '', // 传的参数
      },
      list_index: null,
    };
  },
  mounted() {
    this.size = this.g_pageSizeDefault;
    // 初始化获取登陆人员信息
    this.EyaoSaaSQuerySensitiveRecordList();
  },
  methods: {
    getMsgTime() {
      const today = new Date();
      const targetdayMilliseconds = today.getTime() + 1000 * 60 * 60 * 24 * 7;
      today.setTime(targetdayMilliseconds);
      if (!this.formOverall.time) {
        this.get_date(-7, 0, 1);
      }
      if (this.formOverall.time.length === 0) {
        this.get_date(-7, 0, 1);
      }
      let getHours = today.getHours();
      let getMinutes = today.getMinutes();
      let getSeconds = today.getSeconds();
      if (getHours < 10) {
        getHours = `0${getHours}`;
      }
      if (getMinutes < 10) {
        getMinutes = `0${getMinutes}`;
      }
      if (getSeconds < 10) {
        getSeconds = `0${getSeconds}`;
      }
      const times = `${getHours}:${getMinutes}:${getSeconds}`;
      const startTime = `${this.formOverall.time[0]} ${times}`;
      const endTime = `${this.formOverall.time[1]} ${times}`;
      return [
        moment(startTime).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        moment(endTime).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      ];
    },
    // 监控记录列表
    async EyaoSaaSQuerySensitiveRecordList() {
      this.tableLoading = true;
      const req = Object.assign({
        msg_time: this.getMsgTime(),
        limit: this.size,
        page: this.currentPage,
        user_name: this.formOverall.name,
      });
      console.log(req);
      try {
        EyaoSaaSQuerySensitiveRecordList(req)
          .then((res) => {
            if (res) {
              this.tableLoading = false;
              this.bottonLoading = false;
              const { RecordList } = res;
              const RecordListS = [];
              for (let i = 0; i < RecordList.length; i++) {
                RecordList[i].RecordListSubordinate = [];
                RecordListS.push(RecordList[i]);
              }
              this.tableDataOverall = RecordList;
              this.total = Number(res.total);
            } else {
              this.tableLoading = false;
              this.bottonLoading = false;
              this.tableDataOverall = [];
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (err) {
        this.tableLoading = false;
        this.bottonLoading = false;
        this.tableDataOverall = [];
      }
    },
    get_date(num, num2, type) {
      this.periodActive = type;
      const date = new Date(); // 获取今天的时间
      const newDate = new Date(date);
      const newDate2 = new Date(date);
      newDate.setDate(date.getDate() + num);
      newDate2.setDate(date.getDate() + num2);
      let getMonth1 = newDate.getMonth() + 1;
      let getDate1 = newDate.getDate();
      let getMonth2 = newDate2.getMonth() + 1;
      let getDate2 = newDate2.getDate();
      if (getMonth1 < 10) {
        getMonth1 = `0${getMonth1}`;
      }
      if (getDate1 < 10) {
        getDate1 = `0${getDate1}`;
      }
      if (getMonth2 < 10) {
        getMonth2 = `0${getMonth2}`;
      }
      if (getDate2 < 10) {
        getDate2 = `0${getDate2}`;
      }
      // num为正数时，获取后num天 ，为负数时，获取前num天，0表示今天。
      const newDay = `${newDate.getFullYear()}-${getMonth1}-${getDate1}`;
      const newDay2 = `${newDate2.getFullYear()}-${getMonth2}-${getDate2}`;

      this.$set(this.formOverall, 'time', [newDay, newDay2]);
    },
    // 展开详情
    openDetail(data, index) {
      if (this.list_index === index) {
        this.list_index = null;
        return false;
      }
      this.list_index = index;

      const { user_id } = data;
      this.EyaoSaaSQuerySensitiveRecord(user_id, index);
    },
    // 获取敏感词列表下级
    async EyaoSaaSQuerySensitiveRecord(userid, index) {
      const req = Object.assign({
        userid,
        page: 1,
        limit: 100,
        msg_time: this.getMsgTime(),
      });
      console.log(req);
      EyaoSaaSQuerySensitiveRecord(req)
        .then((res) => {
          if (res) {
            const { list } = res;
            this.tableDataOverall[index].RecordListSubordinate = list;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    /* 获取列表接口 */
    async getListData() {
      const result = await this.$requestData('/api/release/manager/mini', {
        articleList: '',
      });
      result && this.$message(result.data.msg);
    },
    // 导出
    async summaryDataExport() {
      this.ExportLoading = true;
      EyaoSaaSDownloadSensitiveRecords()
        .then((res) => {
          if (res) {
            setTimeout(() => {
              this.downloadFile(res.Data, '整体表格数据.xlsx');
              this.ExportLoading = false;
            }, 3000);
          } else {
            this.$message.error('导出失败');
            this.ExportLoading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.ExportLoading = false;
        });
    },
    downloadFile(url, fileName) {
      const x = new XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
      this.$message.success('导出成功');
    },
    // 筛选
    onSubmitOverall() {
      this.tableLoading = true;
      this.bottonLoading = true;
      this.currentPage = 1;
      this.list_index = null;
      this.EyaoSaaSQuerySensitiveRecordList();
    },
    // 选择页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.EyaoSaaSQuerySensitiveRecordList();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.size = val;
      this.EyaoSaaSQuerySensitiveRecordList();
    },
    // 时间转时间戳
    timeToNumber(time) {
      const date = new Date(time.replace(/-/g, '/'));
      const result = date.getTime();
      return result;
    },
  },
};
</script>
<style scoped lang="scss">
.data-up {
  .item-more {
    .release-list {
      border: none;
      border-radius: 0;
    }
  }
  .data-overall-filter {
    position: relative;
    margin-top: 16px;
    font-size: 16px;
    .el-form {
      position: relative;
      display: flex;
      min-width: 1200px;
    }
    .el-button--primary {
      width: 128px;
      height: 48px;
      cursor: pointer;
      background: #2f96ff;
      border-radius: 8px;
    }
    .el-button--primary:hover {
      color: #fff;
      background: #63b0ff;
    }

    .data-Export:hover {
      background: rgba(0, 0, 0, 0.04);
    }

    .release-select {
      height: 48px;
      border-radius: 8px;
    }
  }
  .periodListBox {
    display: flex;
    margin-right: 10px;
    vertical-align: middle;
  }
  .data-el-table {
    margin-top: 16px;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }
}
.data-Export {
  position: absolute;
  top: 0;
  right: 0;
  width: 128px;
  height: 48px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  .data-Export-img {
    position: absolute;
    top: 11px;
    right: 87px;
    width: 26px;
    height: 26px;
  }
  .Export {
    position: absolute;
    top: 14px;
    right: 15px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0;
    color: #606266;
    text-align: center;
  }
}
.periodList {
  display: flex;
  .buttonItem {
    display: inline-block;
    height: 46px;
    padding: 0 15px;
    line-height: 46px;
    vertical-align: middle;
    cursor: pointer;
    border: 1px solid #ccc;
    border-right: 0;
    &:hover {
      color: #fff;
      background: #63b0ff;
    }
    &.active {
      color: #fff;
      background: #63b0ff;
    }
    &:first-of-type {
      border-radius: 5px 0 0 5px;
    }
    &:last-of-type {
      border-right: 1px solid #ccc;
      border-radius: 0 5px 5px 0;
    }
  }
}
.pagination {
  float: right;
  margin-top: 12px;
  background: #fff;
}
.release-list {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  .release-list-header {
    display: flex;
    width: 100%;
    height: 48px;
    font-size: 16px;
    background: #f5f7fa;
    .release-list-header-item {
      display: inline-block;
      height: 100%;
      padding-left: 24px;
      margin-right: 8px;
      line-height: 48px;
      letter-spacing: 0;
      color: #303133;
    }
  }
}
#min-h-id {
  min-height: 425px;
}
.release-list-body {
  width: 100%;
  .release-list-noData {
    width: 100%;
    height: 100%;
    text-align: center;
    .release-list-noData-img {
      width: 240px;
      height: 192px;
      margin-top: 100px;
    }
    .release-list-noData-word {
      height: 22px;
      margin-top: 16px;
      font-size: 16px;
      color: #909399;
      text-align: center;
    }
  }
  .release-list-item {
    display: flex;
    color: #606266;
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
    flex-wrap: wrap;
  }
  .release-list-item:nth-child(1) {
    display: flex;
    margin-top: 8px;
    color: #606266;
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
  .release-list-item:nth-child(30n) {
    display: flex;
    color: #606266;
    border-bottom: none;
  }
  .item-more {
    flex-basis: 100%;
  }
  .item-time {
    position: relative;
    display: table;
    height: 56px;
    padding-left: 24px;
    margin-right: 8px;
    .item-time-inner {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      max-height: 85%;
      overflow: hidden;
    }
    .item-time-inners {
      position: absolute;
      top: 50%;
      font-size: 14px;
      color: #606266;
      transform: translate(0, -50%);
    }
  }
}
.item-width-subordinate1 {
  width: 15%;
  min-width: 48px;
}
.item-width-subordinate2 {
  width: 20%;
  min-width: 48px;
}
.item-width-content {
  width: 25%;
  min-width: 48px;
}
.item-width-time {
  width: 24%;
  min-width: 48px;
}
.item-width-auth {
  width: 24%;
  min-width: 48px;
}
.item-width-account {
  width: 24%;
  min-width: 48px;
}
.item-width-num {
  width: 25%;
  min-width: 48px;
}
.item-width-activeone {
  width: 13%;
  min-width: 48px;
}
.item-width-Reading {
  width: 11%;
  min-width: 60px;
}
.item-width-Forward {
  width: 13%;
  min-width: 48px;
}
.item-width-Collect {
  width: 9.5%;
  min-width: 48px;
}
.item-width-title {
  width: 10%;
  min-width: 48px;
}

.item-more {
  .release-list-body .release-list-item {
    flex-wrap: nowrap;
  }
  .release-list-header {
    border-top: 1px solid rgba(0, 0, 0, 0.07);
  }
}
.tree-icon {
  display: inline-block;
  padding: 6px;
  transition: transform 0.2s ease-in-out;
  &.on {
    transform: rotate(90deg);
  }
  &:after {
    color: #909399;
    content: '▶';
  }
}
.el-button-group > .el-button {
  height: 48px;
}
::v-deep {
  .release-label .el-date-editor--daterange.el-input,
  .el-date-editor--daterange.el-input__inner,
  .el-date-editor--timerange.el-input,
  .el-input__inner {
    height: 46px;
    line-height: 46px;
  }
  .release-list .path {
    stroke: #2f96ff;
  }
  .pagination .el-input__inner {
    // width: 46px;
    height: 24px;
    border-radius: 3px;
  }
  .pagination .number {
    color: #606266;
  }
  .pagination .active {
    color: #2f96ff !important;
  }
  .release-label .el-form-item__label {
    height: 48px;
    line-height: 48px;
    color: #303133;
    text-align: left;
  }
  .release-select .el-input__inner {
    padding-top: 1px;
  }
  .release-label.el-form-item__label {
    font-size: 16px;
    color: #303133;
  }
  .release-label .el-range__close-icon {
    margin-right: 10px;
  }
}
</style>
